/* global jQuery espn */
import { getCricketCanonical } from 'lib/utils/common'

export const meta = {

  update(meta = {}) {
    const metaDescriptors = [ {
      selector: 'title',
      prop: 'title'
    },{
      selector: 'meta[name="description"]',
      prop: 'description'
    },{
      selector: 'meta[name="keywords"]',
      prop: 'keywords'
    },{
      selector: 'link[rel="canonical"]',
      prop: 'canonical',
      attr: 'href'
    },{
      selector: 'meta[name="twitter:site"]',
      prop: 'site'
    },{
      selector: 'meta[name="twitter:url"]',
      prop: 'canonical'
    },{
      selector: 'meta[name="twitter:title"]',
      prop: 'title'
    },{
      selector: 'meta[name="twitter:description"]',
      prop: 'description'
    },{
      selector: 'meta[name="twitter:image"]',
      prop: 'image'
    },{
      selector: 'meta[property="og:site_name"]',
      prop: 'site_name'
    },{
      selector: 'meta[property="og:url"]',
      prop: 'canonical'
    },{
      selector: 'meta[property="og:title"]',
      prop: 'title'
    },{
      selector: 'meta[property="og:description"]',
      prop: 'description'
    },{
      selector: 'meta[property="og:image"]',
      prop: 'image'
    },{
      selector: 'meta[name="title"]',
      prop: 'title'
    },{
      selector: 'meta[name="medium"]',
      prop: 'website'
    },{
      selector: 'meta[name="news_keywords"]',
      prop: 'keywords'
    } ]

    try {
      const domain = espn.i18n && espn.i18n.domain || window.location.hostname
      let origin = `http://${domain}`
      metaDescriptors.map(descriptor => {
        const prop = descriptor.prop
        const selector = descriptor.selector
        let value = meta[ prop ]
        let attr = descriptor.attr || 'content'

        if(prop == 'title') {
          if(selector === 'title') {
            jQuery(document).attr('title', value)
          }else{
            jQuery(descriptor.selector).attr(attr, value)
          }
        }else{
          let pathname = window.location.pathname
          if(prop === 'canonical' && pathname) {
            const search = window.location.search
            if (meta.sport === 'cricket') {
              pathname = getCricketCanonical(pathname, domain)
            }
            value = `${origin}${pathname}${search}`
          }
          if(prop == 'site') {
            value = 'ESPN'
          }
          jQuery(descriptor.selector).attr(attr, value)
        }

      })
    }catch(e) {
      console.log(e)
    }
  }
}

export default meta



// WEBPACK FOOTER //
// ../app/lib/utils/meta.js